/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize General Social Risk Register List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './GeneralSocialRiskRegisterListView';

export const mapStateToPropsGeneralSocialRiskRegisterList = mapStateToProps;
export const mapDispatchToPropsGeneralSocialRiskRegisterList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsGeneralSocialRiskRegisterList,
  mapDispatchToPropsGeneralSocialRiskRegisterList
)(View);
